"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    close: 'סגירה',
    confirm: 'אישור',
    hello_user_name: 'היי {X},',
    good_to_have_you: 'שמחים שהתחברת.',
    message_part1: 'נראה שהפרטים שלך טרם עודכנו.',
    message_part1_male: 'נראה שפרטיך טרם עודכנו באתר.',
    message_part1_female: 'נראה שפרטייך טרם עודכנו באתר.',
    message_part2: ' לוקח לנו 24 שעות לעדכן אז שווה לחזור שוב.',
    what_to_do_part1: 'אם הודעה זו חוזרת יש לפנות למזכירות בית הספר או ללחוץ על ',
    support_link: 'תמיכה והדרכה',
    what_to_do_part2: ' ליצירת קשר עם התמיכה.'
  },
  ar: {
    close: 'إغلاق',
    confirm: 'موافقة',
    hello_user_name: 'مرحبًا {X},',
    good_to_have_you: 'يسرّنا أنّكِ شبكتَ.',
    message_part1: 'يبدو أنّ تفاصيلكَ لم يتمّ تحديثها على الموقع بعدُ.',
    message_part1_male: 'يبدو أنّ تفاصيلكَ لم يتمّ تحديثها على الموقع بعدُ.',
    message_part1_female: 'يبدو أنّ تفاصيلكِ لم يتمّ تحديثها على الموقع بعدُ.',
    message_part2: ' يستغرق الأمر 24 ساعة للتحديث، لذا من المُجدي العودة مرّة أخرى.',
    what_to_do_part1: 'إذا تكرّرت هذه الرسالة، عليك الاتّصال بسكرتيرة المدرسة أو النقر على ',
    support_link: 'على الدعم والمساعدة',
    what_to_do_part2: ' للاتّصال بالدعم.'
  },
  en: {
    close: 'Close',
    confirm: 'OK',
    hello_user_name: 'Hi {X},',
    good_to_have_you: 'It is so good to see you.',
    message_part1: "It looks like your details haven't been updated yet.",
    message_part2: " It takes us 24 hours to update so it's worth coming back again.",
    what_to_do_part1: 'If this message comes back, contact the school secretary or click on ',
    support_link: 'help',
    what_to_do_part2: ' to contact support.'
  }
};
exports.labels = labels;